import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {
	const btnState = props?.active ? "clicked" : "default";
	const button   = theme.other.colors.tertiaryBtn;

	const hoverColor           = props?.active ? button[btnState].text : button.hover.text;
	const hoverBackgroundColor = props?.active ? button[btnState].background : button.hover.background;

	const padding      = props?.size === "small" ? "0.5rem 2rem" : "0.5rem 3rem";
	const borderRadius = props?.size === "small" ? "0.8rem" : theme.other.isMobile ? "0.5rem" : "1rem";
	const fontSize     = props?.size === "small" ? "1.3rem" : "1.5rem";

	return ( {
		tertiaryButton: {
			color         : button.default.text,
			background    : props?.active ? button.clicked.background : button.default.background,
			borderRadius  : borderRadius,
			height        : "unset !important",
			lineHeight    : "unset !important",
			outlineColor  : `${ button.default.border }`,
			outlineWidth  : `${ theme.other.darkMode ? "1px" : "2px" }`,
			outlineStyle  : "solid",
			padding       : padding,
			textTransform : "none",
			...( props?.fullWidth && { width: "100%" } ),

			"&:hover": {
				color        : hoverColor,
				background   : hoverBackgroundColor,
				outlineColor : `${ button.default.border }`,
				outlineWidth : `${ theme.other.darkMode ? "1px" : "2px" }`,
				outlineStyle : "solid"
			}

		},
		buttonText: {
			color      : button[btnState].text,
			fontWeight : theme.other.typographyNew.fontWeightMapping[props?.fontWeight],
			fontSize   : fontSize
		}
	} );
} );

